import { FC } from 'react';
import { Table, Divider, Space } from 'antd';
import { ArrowLeftOutlined, FileSearchOutlined } from '@ant-design/icons';
import FleetTitle from '@/libs/antd/components/Title';
import { useApp } from '@/App';
import DataRow from '@/libs/antd/components/DataRow';
import { useMPPSLIKHistory } from '@/libs/fleet-api/services/mpp';
import dayjs from 'dayjs';
import { useModals } from '@/components/modals/ModalProvider';

const HistorySLIKMPPListPage: FC<{
	customerId: string;
	customerName: string;
	bmppGroupName: string;
	bmppGroupId: string;
}> = ({ customerId, customerName, bmppGroupId, bmppGroupName }) => {
	const { openCustomerGroupDetail, openCustomerDetail } = useModals();
	const { navigate } = useApp();

	const { data, isFetching } = useMPPSLIKHistory(customerId);
	const dataSource =
		data?.data?.history?.map((record, key) => {
			return {
				...record,
				key,
			};
		}) ?? [];

	return (
		<Space
			direction="vertical"
			style={{ display: 'flex' }}
			size={'large'}
		>
			<div
				style={{
					display: 'flex',
					gap: 10,
					marginBottom: 30,
				}}
			>
				<div>
					<button
						style={{
							display: 'flex',
							height: 44,
							width: 44,
							fontSize: 24,
							border: 'none',
							alignItems: 'center',
							justifyContent: 'center',
							background: '#1557BC',
							color: 'white',
							cursor: 'pointer',
						}}
						onClick={() => {
							navigate('MPPListPage');
						}}
					>
						<ArrowLeftOutlined />
					</button>
				</div>
				<div style={{ flex: 1 }}>
					<FleetTitle>View History Pengecekan SLIK</FleetTitle>
				</div>
			</div>
			<DataRow
				items={[
					[
						[
							'Nama Customer',
							<a
								href="#"
								onClick={() => openCustomerDetail(customerId)}
							>
								{customerName}
							</a>,
						],
						[
							'Group Customer BMPP',
							<a
								href="#"
								onClick={() => openCustomerGroupDetail(bmppGroupId)}
							>
								{bmppGroupName}
							</a>,
						],
					],
				]}
			/>

			<Divider style={{ margin: 0 }} />

			<Table
				loading={isFetching}
				bordered
				scroll={{ x: 'max-content' }}
				dataSource={dataSource}
				columns={[
					{
						title: 'No',
						fixed: 'left',
						align: 'center',
						width: 1,
						render: (_, __, index) => index + 1,
					},
					{
						title: 'No. Referensi',
						render: (_, record) => record.referenceNumber ?? '-',
					},
					{
						title: 'Tanggal Request SLIK',
						render: (_, record) =>
							record.createdAt
								? dayjs(record.createdAt).format('DD/MM/YYYY')
								: '-',
					},
					{
						title: 'Tanggal Update Terakhir',
						render: (_, record) =>
							record.lastModifiedAt
								? dayjs(record.lastModifiedAt).format('DD/MM/YYYY')
								: '-',
					},
					{
						title: 'View SLIK',
						align: 'center',
						render: (_, record) => {
							return (
								<a
									href="#"
									onClick={(e) => {
										e.preventDefault();
										navigate('HistorySLIKMPPPage', {
											mppSlikInquiryId: record.id,
											onBack: () => {
												navigate('HistorySLIKMPPListPage', {
													customerId,
													customerName,
													bmppGroupId,
													bmppGroupName,
												});
											},
										});
									}}
								>
									<FileSearchOutlined />
								</a>
							);
						},
					},
				]}
				pagination={false}
			/>
		</Space>
	);
};

export default HistorySLIKMPPListPage;
